// Lazy pages: loaded on their first visit instead of with the app. Each gets its own chunk with the
// modules only it uses (see `codeSplitting` in vite.config.js); `components.js` leaves them out of
// its eager glob, so a page listed here must be excluded there too.
const LAZY = import.meta.glob(['../components/tpl/tpl-feat.fez', '../components/tpl/tpl-calendar-label.fez'])

// page name (`tpl-feat`) -> its import; dropped once the page has registered
const loaders = Object.fromEntries(Object.entries(LAZY).map(([path, load]) => [path.match(/([^/]+)\.fez$/)[1], load]))
const pending = {}

/**
 * Null when page `name` can mount now (an eager page, or a lazy one already loaded); else the promise
 * of its chunk, started by the first call. A failed load is retried by the next call.
 */
export function loadPage(name) {
  if (!loaders[name]) return null
  pending[name] ??= loaders[name]().then(
    () => {
      delete loaders[name]
      delete pending[name]
    },
    (error) => {
      delete pending[name]
      throw error
    },
  )
  return pending[name]
}
